import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { GetLicenciaAccesoUrlResponse, LicenciaContenidosItem, LicenciaSinCredencialItem } from "../models/dataModels";
import { ResultOk } from "../utils/ActionResults";
import { AlertsService } from "../utils/AlertsService";
import { ApiFetcher } from "../utils/ApiFetcher";
import { I18n } from "../utils/I18n";
import { Loading } from "../utils/Loading";
import { logAndExtractInfoFromException } from "../utils/ValuesFormatter";
import { IntroducirLicenciasService, notificarCredencialesGuardadas, TablaLicenciasPendientes } from "./IntroducirLicencias";


interface ContenidoProps {
    licencia: LicenciaContenidosItem;
}

interface ContenidoState {
    loading: boolean;
    textToShowInError: string;
    textToShowInMessage: string;
    htmlToInject: string;

    /**
     * Licencias pendientes de código con el mismo ISBN que la que se ha intentado abrir: si hay,
     * el aviso de acceso denegado ofrece introducir el código ahí mismo.
     */
    licenciasPendientes: LicenciaSinCredencialItem[];
    huboGuardado: boolean;
}

/***
 * Esta clase se encarga de pintar los enlaces de las licencias en la home.
 * 
 */
export default class LicenciaEnlace extends React.Component<ContenidoProps, ContenidoState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            textToShowInError: null,
            textToShowInMessage: null,
            htmlToInject: null,
            licenciasPendientes: [],
            huboGuardado: false
        };
    }

    public render() {

        var style = {} as React.CSSProperties;
        if (!this.props.licencia.puedeInteractuar) {
            style.backgroundColor = "unset";
        }

        return <div className="ficha-cont" style={style}>
            {this.state.textToShowInError != null && this.state.licenciasPendientes.length == 0 &&
                <ResultOk messageToShow={this.state.textToShowInError} onDismiss={() => this._onCerrarError()} />
            }

            {this.state.textToShowInError != null && this.state.licenciasPendientes.length > 0 &&
                this._pintarErrorConLicenciasPendientes()
            }

            {this.state.textToShowInMessage != null &&
                <Modal id="mdlAccesoContenido" isOpen={true} toggle={() => this.setState({ textToShowInMessage: null })}>
                    <ModalHeader
                        close={<button className="btn-close" onClick={() => this.setState({ textToShowInMessage: null })} />}
                    >
                    </ModalHeader>
                    <ModalBody>
                        <div
                            onClick={(evt) => {
                                var target = (evt.target as HTMLElement);
                                if (target.classList.contains("copy-clip")) {
                                    navigator.clipboard.writeText(target.textContent)
                                        .then(() => {
                                            target.classList.add('flash');
                                            // Eliminar clase después de 2 segundos
                                            setTimeout(() => {
                                                target.classList.remove('flash');
                                            }, 2000);
                                        })
                                        .catch((err) => alert("No se ha podido copiar"));
                                }
                            }}
                            dangerouslySetInnerHTML={{ __html: this.state.textToShowInMessage }}
                        >
                        </div>
                    </ModalBody>
                </Modal>
            }

            {this.state.loading && <Loading />}
            <div className="imagen-cont">

                <a href="#" onClick={(evt) => this.accederPlataformaEditorial(evt, this.props.licencia)} target="_blank">
                    <img src={this.props.licencia.caratula} className="img-fluid" alt={this.props.licencia.nombre} />
                </a>

            </div>
            <div className="tit-cont">
                {this.props.licencia.nombre}
            </div>
            <div className="autor-cont">
                <div className="editorial">
                    {(this.props.licencia.editorialNombre || "").length != 0 && <>{this.props.licencia.editorialNombre}</>}
                    {(this.props.licencia.editorialNombre || "").length == 0 && <>{I18n.Strings.getEnumText(`Editorial.${this.props.licencia.editorial}`)}</>}
                </div>

                {this.props.licencia.clase}
            </div>
            {this.state.htmlToInject != null && <div dangerouslySetInnerHTML={{ __html: this.state.htmlToInject }}></div>}
        </div>;
    }

    private accederPlataformaEditorial(evt: React.MouseEvent<HTMLAnchorElement>, licencia: LicenciaContenidosItem) {
        evt.preventDefault();

        this.setState({ loading: true },
            () => {

                var apiFetcher = new ApiFetcher();
                var prom = apiFetcher.getByUrl<GetLicenciaAccesoUrlResponse>(`intranet/licencias/mias/${licencia.licenciaContenidoId}/acceder`);


                prom.then((result: GetLicenciaAccesoUrlResponse) => {

                    if (result.puedeAcceder) {
                        this.realizarAcceso(result);
                    }
                    else {
                        this.mostrarAccesoDenegado(licencia, result.mensajeUsuario);
                    }
                })
                    .catch((error) => {
                        this.setState({
                            loading: false,
                            textToShowInError: logAndExtractInfoFromException(error)
                        });
                    });
            }
        );
    }

    /***
     * Muestra el motivo por el que no se puede acceder. Si la licencia está pendiente de que el
     * alumno introduzca su código (p. ej. "La licencia no tiene credenciales asociadas"), el aviso
     * incluye los campos para introducirlo, junto con los de las demás licencias del mismo ISBN.
     */
    private mostrarAccesoDenegado(licencia: LicenciaContenidosItem, mensaje: string) {

        var service = new IntroducirLicenciasService();

        service.getPendientesMismoIsbn(licencia.licenciaContenidoId)
            // Si falla la consulta se muestra el aviso tal cual, sin campos.
            .catch(() => [] as LicenciaSinCredencialItem[])
            .then(licenciasPendientes => {
                this.setState({
                    loading: false,
                    textToShowInError: mensaje,
                    licenciasPendientes: licenciasPendientes,
                    huboGuardado: false
                });
            });
    }

    private _onCerrarError() {
        var huboGuardado = this.state.huboGuardado;

        this.setState({ textToShowInError: null, licenciasPendientes: [], huboGuardado: false }, () => {
            if (huboGuardado) {
                notificarCredencialesGuardadas();
            }
        });
    }

    private _pintarErrorConLicenciasPendientes(): JSX.Element {

        return <Modal isOpen={true} className="modal-lg" toggle={() => this._onCerrarError()}>
            <ModalHeader close={<button className="btn-close" onClick={() => this._onCerrarError()} />}>
            </ModalHeader>
            <ModalBody>
                {!this.state.huboGuardado && <div dangerouslySetInnerHTML={{ __html: this.state.textToShowInError }}></div>}

                <p className="mt-3">{I18n.Strings.introducirLicencias.descripcionDesdeAcceso}</p>

                <TablaLicenciasPendientes
                    licencias={this.state.licenciasPendientes}
                    onCredencialGuardada={() => this.setState({ huboGuardado: true })}
                />
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => this._onCerrarError()}>
                    {I18n.Strings.ok}
                </Button>
            </ModalFooter>
        </Modal>;
    }

    /***
     * Ejecuta el acceso al contenido de una respuesta que ya viene con puedeAcceder: salto a la
     * url, inyeccion del formulario o mensaje, segun lo que traiga la respuesta. El mensaje de
     * acceso de la credencial del colegio (mensajePrevioAcceso) lo integra cada rama en su propio
     * popup, para que el alumno nunca vea dos ventanas seguidas.
     */
    private realizarAcceso(result: GetLicenciaAccesoUrlResponse) {

        if ((result.url || "").length > 0) {
            this.abrirUrl(result);
        }
        else if ((result.htmlToInject || "").length > 0) {
            this.abrirForm(result);
        }
        else if ((result.mensajeUsuario || "").length > 0 || (result.mensajePrevioAcceso || "").length > 0) {
            // No hay salto: el mensaje de la credencial va debajo del texto que ya se mostraba.
            this.setState({
                loading: false,
                textToShowInMessage: this.componerConMensajePrevio(result.mensajeUsuario, result.mensajePrevioAcceso)
            });
        }
        else {
            alert("No Implementado!");
        }
        this.setState({ loading: false });
    }

    /***
     * Encadena un texto HTML con el mensaje de acceso de la credencial del colegio, que siempre
     * va debajo. Cualquiera de los dos puede venir vacio.
     */
    private componerConMensajePrevio(mensaje: string, mensajePrevioAcceso: string): string {

        if ((mensajePrevioAcceso || "").length == 0) {
            return mensaje;
        }

        if ((mensaje || "").length == 0) {
            return mensajePrevioAcceso;
        }

        return `${mensaje}<div class="mensaje-acceso-credencial">${mensajePrevioAcceso}</div>`;
    }

    private abrirUrl(result: GetLicenciaAccesoUrlResponse) {

        // Con mensaje de acceso configurado el salto no puede ser directo: se muestra un unico
        // popup con el mensaje y se salta al aceptarlo. Al ser el Aceptar un gesto del usuario, el
        // navegador no bloquea la ventana; y si aun asi la bloquea no pedimos un segundo Aceptar
        // (ya lo tenemos), abrimos el contenido en esta misma ventana.
        if ((result.mensajePrevioAcceso || "").length > 0) {

            this.setState({ loading: false }, () => {
                AlertsService.showAlertMessage(result.mensajePrevioAcceso,
                    () => {
                        var resultWindow = window.open(result.url, "_blank");
                        if (!resultWindow) {
                            window.location.href = result.url;
                        }
                    });
            });
            return;
        }

        var resultWindow = window.open(result.url, "_blank");

        if (!resultWindow) {

            this.setState({ loading: false }, () => {
                AlertsService.showAlertMessage(`<p>Parece, que su dispositivo tiene activado el bloqueador de popups, asi que los contenidos se abrir&aacute;n en esta misma ventana.</p>
                        <p>Para permitir que se abran los contenidos en otra ventana, siga las siguientes instrucciones:</p>
                        <ul>
                            <li>
                                <a target="_blank" href='https://support.google.com/chrome/answer/95472?hl=es&co=GENIE.Platform%3DDesktop#zippy=%2Cpermitir-las-ventanas-emergentes-y-las-redirecciones-de-un-sitio'>
                                Si est&aacute; usando Chrome (Secci&oacute;n "Permitir las ventanas emergentes y las redirecciones de un sitio")
                                </a>
                            </li>
                            <li>
                                <a target="_blank" href="https://support.apple.com/es-es/guide/safari/sfri40696/mac">
                                Si est&aacute; usando Safari
                                </a>
                            </li>
                        </ul>
                        <p>Para acceder al contenido, pulse sobre <b>Aceptar</b></p>
                    `,
                    () => {
                        window.location.href = result.url;
                    });
            });
            return false;
        }
    }

    private abrirForm(result: GetLicenciaAccesoUrlResponse) {

        // Igual que en el salto por url: si hay mensaje de acceso, un solo popup y el formulario
        // se inyecta al aceptarlo.
        if ((result.mensajePrevioAcceso || "").length > 0) {

            this.setState({ loading: false }, () => {
                AlertsService.showAlertMessage(result.mensajePrevioAcceso,
                    () => this.inyectarForm(result));
            });
            return;
        }

        this.inyectarForm(result);
    }

    /***
     * Inyecta en la ficha el formulario de salto que devuelve el proveedor y ejecuta su script.
     */
    private inyectarForm(result: GetLicenciaAccesoUrlResponse) {
        this.setState({ htmlToInject: result.htmlToInject },
            () => {
                if ((result.scriptToInject || "").length != 0) {
                    eval(result.scriptToInject);
                }
            }
        );
    }
}